import { ContentFView } from './ContentFView'

export function ContentFPage() {
  return <ContentFView />
}
